import React, { useEffect, useState } from 'react'
import NumberInput from '../../../../../elements/NumberInput/NumberInput'
import { checkRegEx } from '../../../../helpers/checkers'
import { regexes } from '../../../../helpers/regex'

interface Number_Of_Rolls_Props {
  rollNumber: string
  title: string
  handleRollNumber: (s: string) => void
}

export default function NumberOfRolls({
  rollNumber,
  title,
  handleRollNumber,
}: Number_Of_Rolls_Props) {
  const [rollValue, setrollValue] = useState<string>('')
  const maxRoll = 9999
  const handleChange = (e: any) => {
    const value = e.target.value
    if (checkRegEx(value, regexes.wholeNumbers)) {
      setrollValue(value)
    }
  }
  const handleBlur = (s: any) => {
    const value = s.target.value
    value <= maxRoll
      ? (handleRollNumber(value), setrollValue(value))
      : (handleRollNumber(maxRoll.toString()), setrollValue(value))
  }

  useEffect(() => {
    setrollValue(rollNumber)
    handleRollNumber(rollNumber)
  }, [rollNumber])

  return (
    <NumberInput
      value={rollValue}
      handleBlur={handleBlur}
      handleChange={handleChange}
      title={title}
      placeholder={''}
      rolls
      fontSize='20px'
      width='148.5px'
      height='42px'
      padding='7px 10px'
      h='24px'
      maxLength={4}
      name='ROLL_NUMBER'
    />
  )
}
